/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_BrewInputs */

const vi_media_field_brew = /** @type {(inputs: Media_Field_BrewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách pha`)
};

/**

* @param {Media_Field_BrewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_brew = /** @type {((inputs?: Media_Field_BrewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_BrewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_brew(inputs)
});